module.exports = __webpack_public_path__ + "img/i3.83c15d59.svg";